import styled from 'styled-components';

const ButtonWrapper = styled.div``;

ButtonWrapper.displayName = 'ButtonWrapper';

export default ButtonWrapper;
